import React from 'react';
import Container from "components/Container";
import Footer from "components/Footer";
import Header from "components/Header";
import { Outlet } from "react-router-dom";
import PatrocionioErealizacao from 'components/PatrocinioErealizacao';
import eventoSalvadorpc from 'components/assets/imagens/eventoSalvador-pc.jpg'
import MenuFooter from 'components/Footer/MenuFooter';
import { Grid } from '@mui/material';

const BasePage = () => {
	return (
		<main>
			<Header />
			<Grid style={{
				backgroundImage: `url(${eventoSalvadorpc})`,
				backgroundAttachment: 'fixed', backgroundPosition: 'center'
			}}>
				<Container>
					<Outlet />
				</Container>

			</Grid>
			<PatrocionioErealizacao style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }} />
			<MenuFooter />
			<Footer />
		</main>
	);
}

export default BasePage;
